/**
 * Admin Menu Filter CSS classes and IDs.
 *
 * @type {string}
 */

// CSS classes.
export const showItemClass             = 'samf-admin-show-item';
export const hideItemClass             = 'samf-admin-hide-item';
export const adminMenuSearchFieldClass = 'samf-admin-menu-search-field';

// Ids.
export const adminMenuSearch = 'smart-admin-menu-filter-search';

// Attributes.
export const adminMenuFilterName = 'samf-admin-menu-filter';